import { render } from "./customers.vue?vue&type=template&id=38c0eeca&scoped=true&ts=true"
import script from "./customers.vue?vue&type=script&lang=ts"
export * from "./customers.vue?vue&type=script&lang=ts"

import "./customers.vue?vue&type=style&index=0&id=38c0eeca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c0eeca"]])

export default __exports__